export const list_ico = '/img/ico';
export const api = 'https://www.thecocktaildb.com/api/json/v1/1/';